import {initSelects} from "../../core/js/Select.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url === "pois-page-aide") {
        const options = {
            info: false,
            paging: false,
            columnDefs: [
                {targets: [0, 3], searchtype: "text"},
                {targets: [2], searchtype: "select"},
                {targets: [1, 4], searchtype: "disabled"},
                {targets: [0], width: 60},
                {targets: [1], width: 10},
                {targets: [2], width: 185},
                {targets: [3], width: 185},
                {targets: [4], width: 185}
            ],
            fixedColumns: true,
            order: [[0, "asc"]]
        }
        window?.createDatatable('#pois-list', options, '#data-search', '#data-filter-btn')
        initSelects()
    }
})